<!-- 产品库存周期-->
<template>
  <div class="app-container">
    <Table
      ref="tableRef"
      :showSearchIcon="true"
      :showSelectSearch="true"
      :isCreateSearch="false"
      :showText="true"
      :isSelect="true"
      :data="tableData"
      :columns="columns"
      :total="total"
      :loading="loading"
      :pageSize="20"
      height="calc(100vh - 240px)"
      :showPagination="true"
      rowKey="productRecordsId"
      :searchAttrName="searchAttrName"
      :customParamsFun="getCustomParamsFun"
      tableName="warehouseCycle"
      exportDataUrl="/outInputRecords/selectProductOutInRecordDetail"
      @onSearch="handleSearch"
    >
      <template #selectSearch>
        <el-select
          v-model="searchVal['warehouseName']"
          style="width: 200px"
          filterable
          placeholder="请选择仓库"
        >
          <el-option
            v-for="item in warehouseList"
            :key="item.warehouseId"
            :label="item.warehouseName"
            :value="item.warehouseId"
          />
        </el-select>
        <el-select
          class="ml10"
          v-model="searchVal['productName']"
          style="width: 200px"
          filterable
          placeholder="请选择产品"
        >
          <el-option
            v-for="item in productList"
            :key="item.productId"
            :label="item.productName"
            :value="item.productId"
          />
        </el-select>
      </template>
      <template #textInfo>
        <el-row class="textInfo" :gutter="8">
          <!-- <el-col :span="6">
                <div><span class="textName">{{checkInventoryRecord.warehouseName}}</span></div>
            </el-col> -->
          <el-col :span="6">
            <div>
              <span class="textName">入库总量：</span
              >{{ checkInventoryRecord.inInventoryTotal || 0 }}
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span class="textName">出库总量：</span
              >{{ checkInventoryRecord.outInventoryTotal || 0 }}
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span class="textName">实时库存：</span
              >{{ checkInventoryRecord.realInventoryTotal || 0 }}
            </div>
          </el-col>
        </el-row>
      </template>
    </Table>
  </div>
</template>

<script setup>
import Table from "@/components/Element/Table";
import { ref } from "vue";
import { getCustomTableCols } from "@/tableColumn";
import {
  selectProductOutInRecordDetail,
  selectOutAndInAndRealInventoryTotal,
} from "@/api/warehouse/warehouseDate";
import useCacheStore from "@/store/modules/cache";
const cacheStore = useCacheStore();
const warehouseList = cacheStore.warehouse;
const productList = cacheStore.product;
const searchVal = ref({
  warehouseName: warehouseList[0]?.warehouseId,
  productName: productList[0]?.productId,
});
/**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
defineOptions({
  name: "warehouseCycle",
});
const tableData = ref([]);
const tableRef = ref(null);

const total = ref(0);
const loading = ref(false);
const showSearch = ref(true);
const searchAttrName = [];
const checkInventoryRecord = ref({});
const getCustomParamsFun = () => {
  return {
    warehouseId: searchVal.value.warehouseName,
    productId: searchVal.value.productName,
  };
};
// 搜索
const handleSearch = (data) => {
  loading.value = true;
  selectProductOutInRecordDetail(data)
    .then((res) => {
      tableData.value = res.data;
      total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
    })
    .finally(() => {
      loading.value = false;
    });
  selectOutAndInAndRealInventoryTotal({
    warehouseId: data.warehouseId,
    productId: data.productId,
  }).then((res) => {
    checkInventoryRecord.value = res.data;
  });
};

const columns = getCustomTableCols([
  "warehouseName",
  "outInWarehouseName",
  "projectName",
  "outInWarehouseStatus",
  "outInType",
  "outWarehouse",
  "inWarehouse",
  "trackingNumber",
  "returnAddress",
  "batchNo",
  "contractNo",
  "projectNo",
  "remarks",
  "recipient",
  "productName",
  "eqptCode",
  "checkInventoryDisposalMode",
  "productType",
  "supplier",
  "supplierModel",
  "internalModel",
  "usageType",
  "productNum",
  { label: "已完成数量", prop: "completeNum" },
  { label: "未完成数量", prop: "incompleteNum" },
  "operateTime",
  "operatorName",
]);
</script>

<style lang="scss" scoped>
.textInfo {
  font-size: 18px;
  width: 80%;
  color: #ed064b;
  font-weight: bold;
  .textName {
    font-size: 20px;
    color: #555;
  }
}
</style>
